// START IMPORTS
import { MonitoringOverview, useSriracha } from '@ltvco/refresh-lib/v1';
// END IMPORTS

export function Monitoring() {
  // START HOOKS_AND_QUERIES
  const { data } = useSriracha();
  // END HOOKS_AND_QUERIES

  // START DERIVED_DATA_AND_UTILS
  const notifications = data || [];
  // END DERIVED_DATA_AND_UTILS

  // START RENDER
  return <MonitoringOverview notifications={notifications} />;
  // END RENDER
}
